import { Routes, Route, useLocation } from "react-router-dom";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import "./App.css";

// Components
import Layout from "./components/Layout";
import HomePage from "./components/HomePage/HomePage";
import CollectionsPage from "./components/CollectionsPage/CollectionsPage";
import ProductDetails from "./components/ProductPage/ProductDetails";
import StoryPage from "./components/StoryPage/StoryPage";
import LoginPage from "./components/LoginPage/LoginPage";
import ContactPage from "./components/ContactPage/ContactPage";
import CartPage from "./components/CartPage/CartPage";
import CheckoutPage from "./components/CheckoutPage/CheckoutPage";
import OrdersPage from "./components/CheckoutPage/OrdersPage";
import Verify from "./components/CheckoutPage/Verify";
import PaystackVerify from "./components/CheckoutPage/PaystackVerify";

// MAIN APP: Think of this Like a Table Of Contents in a Book
const App = () => {
  const location = useLocation(); // Activates Transition Animation

  return (
    <>
      {/* Pages */}
      <TransitionGroup component={null}>
        <CSSTransition key={location.key} timeout={300} classNames="morph">
          <Routes>
            <Route element={<Layout />}>
              {/* Outlets */}
              <Route index element={<HomePage />} />
              <Route path="/story" element={<StoryPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/cart" element={<CartPage />} />
              <Route path="/checkout" element={<CheckoutPage />} />
              <Route path="/orders" element={<OrdersPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/collections" element={<CollectionsPage />} />
              <Route path="/collections/:id" element={<ProductDetails />} />

              {/* Verify Payment */}
              <Route path="/verify" element={<Verify />} />
              <Route path="/verify-paystack" element={<PaystackVerify />} />
            </Route>
          </Routes>
        </CSSTransition>
      </TransitionGroup>
    </>
  );
};

export default App;
